import React from 'react';

import { Image } from './Image';

export class ImageAndDescr extends React.Component {
  render() {
    const { name, short_name, description } = this.props.attr;

    return (
      <React.Fragment>
        <Image short_name={short_name} />
        <span>{description}</span>
        {/* {'3D' === short_name ? <span>На сеанси у 3D форматі потрібні персональні 3D окуляри.</span> : ''} */}
      </React.Fragment>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/snippets/ExplanationAttributes/impl/share/ImageAndDescr.jsx